/* eslint-disable complexity */
import { STGrouping, STBarGrouping, SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { IChartModel } from '../../Interface/chart-v3/chart-model.interface';
import { IBarChart, ILineChart, ISubChartModel } from '../../Interface/chart-v3/sub-chart';

export function getAvailableTrendline(subChart: ISubChartModel) {
    const chartType = subChart.type;
    switch (chartType) {
        case SubChartType.BarChart:
        case SubChartType.Bar3DChart: {
            const { grouping } = (subChart as IBarChart);
            return grouping !== STBarGrouping.stacked && grouping !== STBarGrouping.percentStacked;
        }
        case SubChartType.LineChart:
        case SubChartType.Line3DChart: {
            const { grouping } = (subChart as ILineChart);
            return grouping !== STGrouping.stacked && grouping !== STGrouping.percentStacked;
        }
        case SubChartType.ScatterChart:
        case SubChartType.BubbleChart:
            return true;
        case SubChartType.PieChart:
        case SubChartType.Pie3DChart:
        case SubChartType.DoughnutChart:
        case SubChartType.RadarChart:
        case SubChartType.AreaChart:
        case SubChartType.Area3DChart:
            return false;
        default:
            return false;
    }
}

export function isTrendlineAvailable(model: IChartModel) {
    const { charts } = model.plotArea;
    return charts.some(chart => getAvailableTrendline(chart));
}
